import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FiCopy, FiMail } from "react-icons/fi";

const CONTACT_EMAIL = "support@serenaspace.com";

function ContactModal({ children, ...buttonProps }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);

      toast({
        title: "Email address copied",
        description: "You can paste it into your preferred email app.",
        status: "success",
        duration: 2500,
        isClosable: true,
        position: "bottom",
      });
    } catch (error) {
      toast({
        title: "Unable to copy automatically",
        description: CONTACT_EMAIL,
        status: "info",
        duration: 4000,
        isClosable: true,
        position: "bottom",
      });
    }
  };

  const handleEmail = () => {
    window.location.href = `mailto:${CONTACT_EMAIL}`;
  };

  return (
    <>
      <Button onClick={onOpen} {...buttonProps}>
        {children}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="blackAlpha.600" />

        <ModalContent borderRadius="xl" mx={4}>
          <ModalHeader
            fontFamily="'Poppins', sans-serif"
            fontWeight="600"
          >
            Let's talk
          </ModalHeader>

          <ModalCloseButton />

          <ModalBody>
            <Stack spacing={4}>
              <Text color="#4c5955" lineHeight="1.7">
                Whether you're exploring research, technology,
                implementation or partnership opportunities, we'd be glad to
                hear from you.
              </Text>

              <Text fontSize="sm" color="#6b7773">
                Choose how you'd like to continue.
              </Text>
            </Stack>
          </ModalBody>

          <ModalFooter gap={3} flexWrap="wrap">
            <Button
              variant="outline"
              leftIcon={<FiCopy />}
              onClick={handleCopy}
            >
              Copy email
            </Button>

            <Button
              bg="#087F73"
              color="white"
              leftIcon={<FiMail />}
              onClick={handleEmail}
              _hover={{ bg: "#066B61" }}
            >
              Open email app
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ContactModal;